<template>
  <div class="c-not-found" :style="{ backgroundImage: `url(${image})` }">
    <div class="container">
      <div class="c-not-found__logo">
        <Logo />
      </div>
      <h2 class="c-not-found__title">
        {{ $t("Sembra che qui non ci sia niente") }}
      </h2>
      <p class="c-not-found__desc">
        {{
          $t(
            "O forse no? Quello che stai cercando non esiste, ma non tutto il male vien per nuocere"
          )
        }}
      </p>
      <div class="c-not-found__redirect-cnt">
        <router-link class="c-not-found__redirect btn-primary" to="/">{{
          $t("Torna alla Home")
        }}</router-link>
      </div>
      <div class="c-not-found__footer">
        {{ $t("Guarda cosa hai guadagnato inserendo") }}
        <span class="primary">fanize</span>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./rebuild/Navigation/Logo";

import { mapGetters } from "vuex";
export default {
  name: "NotFoundPage",
  components: { Logo },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isDesktop", "isMobile", "isTablet"]),
    image() {
      return require("../assets/images/background-mobile-404.jpg");
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.c-not-found {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  padding: 20px;
  text-align: center;
}
.c-not-found__logo {
  display: flex;
  justify-content: center;
  margin-bottom: 100px;

  @media (min-width: 767px) {
    justify-content: flex-start;
    margin-bottom: 150px;
  }
}
.c-not-found__title {
  font-weight: bold;
  font-size: 40px;
}
.c-not-found__desc {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  margin-top: 10px;
}
.c-not-found__redirect-cnt {
  margin-top: 50px;
  margin-bottom: 65px;
}
.c-not-found__redirect {
  padding: 20px 25px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
}
.c-not-found__footer {
  color: #4e4d4d;
}
</style>
